import { memo, useCallback, useEffect, useState } from "react";
import ReactDOM from "react-dom";

import styles from "./ErrorModal.module.css";
import { CloseIcon } from "../../constants/svg";

const ErrorModal = ({ isModalOpen, setModalOpen, children, hasCloseIcon = false, navigate }) => {
	const [modalContainer, setModalContainer] = useState(null);

	useEffect(() => {
		const container = document.createElement("div");
		const modalRoot = document.getElementById("custom-modal");
		if (modalRoot) {
			modalRoot.appendChild(container);
			setModalContainer(container);
		}

		return () => {
			if (modalRoot && container) {
				modalRoot.removeChild(container);
			}
		};
	}, []);

	const onClose = useCallback(() => {
		if (navigate) navigate();
		if (isModalOpen) {
			setModalOpen(false);
		}
	}, [isModalOpen, setModalOpen]);

	return (
		modalContainer &&
		ReactDOM.createPortal(
			<>
				{isModalOpen ? (
					<div className={styles.container} onClick={onClose}>
						<div className={styles.backDrop} />
						<div className={styles.modal} onClick={(e) => e.stopPropagation()}>
						{hasCloseIcon && (
							<span className={styles.closeIcon} onClick={onClose}>
							<CloseIcon />
							</span>
						)}
							{children}
						</div>
					</div>
				) : null}
			</>,
			modalContainer
		)
	);
};

export default memo(ErrorModal);
